import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentSlipsComponent } from './payment-slips.component';

const routes: Routes = [
	{
		path: '',
		component: PaymentSlipsComponent,
	  },
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PaymentSlipsRoutingModule {}
